export default "__VITE_ASSET__DZEInH2h__"